import { apiClient } from "./api";

// Types

export interface PlannerResponse {
  status: string;
  message: string;
}

// Run content planner
export const runContentPlanner = async (
  persona_id: string,
  mock: boolean = false,
): Promise<PlannerResponse> => {
  try {
    const response = await apiClient.post("/api/planner/run", {
      persona_id,
      mock,
    });
    return response.data;
  } catch (error) {
    console.error("Error running content planner:", error);
    throw error;
  }
};
